__turbopack_context__.v({
  "contentWrapper": "oH2HZG_contentWrapper",
  "ctaButton": "oH2HZG_ctaButton",
  "description": "oH2HZG_description",
  "descriptionWithIcons": "oH2HZG_descriptionWithIcons",
  "imageLeft": "oH2HZG_imageLeft",
  "imageWrapper": "oH2HZG_imageWrapper",
  "imageWrapperMobileBottom": "oH2HZG_imageWrapperMobileBottom",
  "imageWrapperMobileTop": "oH2HZG_imageWrapperMobileTop",
  "mobileImageBottom": "oH2HZG_mobileImageBottom",
  "mobileImageTop": "oH2HZG_mobileImageTop",
  "sectionTitle": "oH2HZG_sectionTitle",
  "textWrapper": "oH2HZG_textWrapper",
});
